import React from 'react';

const number = new Intl.NumberFormat('en-US');
const stages = [
  ['generated', 'Generated'],
  ['opened', 'Opened'],
  ['redeemed', 'Joined'],
  ['connected', 'Meta connected'],
  ['activated', 'Agent activated'],
  ['applied', 'First change'],
  ['retained_30d', 'Active after 30d'],
];

function ReferralFunnel({ metrics = {}, label = 'Referral funnel' }) {
  return (
    <div className="referral-funnel" aria-label={label}>
      {stages.map(([key, stageLabel], index) => {
        const value = Number(metrics[key] || 0);
        const previous = index ? Number(metrics[stages[index - 1][0]] || 0) : 0;
        const conversion = previous ? `${Math.round((value / previous) * 100)}%` : '—';
        return (
          <div key={key}>
            <span>{index + 1}</span>
            <strong>{number.format(value)}</strong>
            <small>{stageLabel}</small>
            {index > 0 && <em>{conversion} from prior step</em>}
          </div>
        );
      })}
    </div>
  );
}

export default ReferralFunnel;
